export default "__VITE_PUBLIC_ASSET__280f9ac7__"